import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { useCallback as P, useMemo as h } from "react";
import { u as k } from "../../index-5f46a663.js";
import { bytesToHumanReadable as H } from "../../utils/bytes.es.js";
import { arrayToCommaSeparatedString as S } from "../../utils/text.es.js";
import { useMultiStyleConfig as w, chakra as i } from "@chakra-ui/react";
import { ERROR as b } from "./FileUploader.constants.es.js";
import { Description as G } from "./components/Description.es.js";
import { ErrorMessage as N } from "./components/ErrorMessage.es.js";
import { Heading as Y } from "./components/Heading.es.js";
import { Loading as q } from "./components/Loading.es.js";
import { UploadIcon as B } from "../../icons/index.es.js";
const ne = ({
  accept: s,
  buttonLabel: y,
  descriptionLineOne: v,
  descriptionLineTwo: F,
  error: p,
  isLoading: R = !0,
  maxSize: l,
  maxFiles: t = 1,
  text: T,
  validator: c,
  ...D
}) => {
  const E = P((d) => {
    if (c) {
      const o = c(d);
      if (o)
        return o;
    }
    if (l && d.size > l)
      return {
        code: b.FILE_TOO_LARGE,
        message: `File size must be less than ${H(l)}.`
      };
    if (s && !Object.entries(s).some(([o, u]) => u.map((A) => o.replace("*", A)).includes(d.type))) {
      const o = Object.values(s).flat();
      return {
        code: b.FILE_INVALID_TYPE,
        message: `File type must be ${S(
          o,
          (u) => u.toUpperCase()
        )}`
      };
    }
    return null;
  }, []), { getRootProps: I, getInputProps: O, isDragActive: a, fileRejections: n } = k({
    maxFiles: t,
    validator: E,
    ...D
  }), { container: j, content: z, drag: f, dropdzoneFailedDrag: L, dropzone: g, dropzoneFailed: _, icon: C, root: U } = w("FileUploader"), e = h(() => t && n.length > t ? `Only ${t} file${t > 1 ? "s" : ""} can be uploaded at a time.` : p || (n.length ? n[0].errors[0].message : null), [p, n.length]), $ = h(
    () => ({
      ...g,
      ...a ? f : {},
      ...e != null && e.length ? _ : {},
      ...a && (e != null && e.length) ? L : {}
    }),
    [_, e, f, g, a]
  );
  return /* @__PURE__ */ r(i.div, { ...I(), __css: U, children: /* @__PURE__ */ m(i.div, { __css: $, children: [
    R ? /* @__PURE__ */ r(q, {}) : /* @__PURE__ */ m(i.div, { __css: j, children: [
      /* @__PURE__ */ m(i.div, { __css: z, children: [
        /* @__PURE__ */ r(B, { sx: C }),
        /* @__PURE__ */ r(Y, { text: T, buttonLabel: y }),
        /* @__PURE__ */ r(
          G,
          {
            descriptionLineOne: v,
            descriptionLineTwo: F
          }
        )
      ] }),
      e && /* @__PURE__ */ r(N, { errorMessage: e })
    ] }),
    /* @__PURE__ */ r("input", { "aria-label": "Drag and drop or browse", ...O() })
  ] }) });
};
export {
  ne as FileUploader
};
//# sourceMappingURL=FileUploader.es.js.map
